import { createContext, useContext, useState, type ReactNode } from "react";

interface HeaderActionContextValue {
  action: ReactNode | null;
  setAction: (node: ReactNode | null) => void;
}

const HeaderActionContext = createContext<HeaderActionContextValue>({
  action: null,
  setAction: () => {},
});

export function HeaderActionProvider({ children }: { children: ReactNode }) {
  const [action, setAction] = useState<ReactNode | null>(null);
  return (
    <HeaderActionContext.Provider value={{ action, setAction }}>
      {children}
    </HeaderActionContext.Provider>
  );
}

export function useHeaderAction() {
  return useContext(HeaderActionContext);
}
